import { FastField, Formik } from 'formik';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import ClosePopup from 'Assets/images/close-popup.svg';
import {
  Button,
  Form,
  Grid,
  Modal,
} from 'semantic-ui-react';
import {
  InputField,
  DropdownField,
  SingleDatePickerField,
  PhoneInput,
} from 'Modules/Formik';
import css from './EditClinic.less';
import { schemaValidation } from './Validation';

const initialValues = {
  firstName: '',
  lastName: '',
};

const EditClinic = ({ data, id }) => {
  const ref = useRef(null);

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const onSubmit = async (values) => {
  };

  return (
    <div className={css.container}>
      <Modal
        onClose={onClose}
        open
        closeIcon={<img className={css.closeIcon} src={ClosePopup} alt="close popup" />}
        className={css.customModal}
        size="medium"
      >
        <Modal.Header>Edit Clinic Information</Modal.Header>
        <Modal.Content className={css.modalContent}>
          <Formik
            initialValues={initialValues}
            validationSchema={schemaValidation}
            validateOnChange
            innerRef={ref}
            onSubmit={onSubmit}
          >
            {({ values, errors, touched }) => (
              <Form>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="name"
                        component={InputField}
                        placeholder="Name"
                        label="Name"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="entityName"
                        component={InputField}
                        placeholder="Entity Name"
                        label="Entity Name"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="taxIdentificationNumber"
                        component={InputField}
                        placeholder="Tax Identification Number"
                        label="Tax Identification Number"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="phone"
                        component={PhoneInput}
                        placeholder="Phone"
                        label="Phone"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="email"
                        component={InputField}
                        placeholder="Email"
                        label="Email"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="Roles"
                        component={DropdownField}
                        placeholder="Roles"
                        label="Roles"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <FastField
                        name="address"
                        component={InputField}
                        placeholder="Adress"
                        label="Adress"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            )}
          </Formik>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              ref?.current?.handleSubmit();
            }}
            primary
            className={css.submitBtn}
          >
            Add
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default EditClinic;
